// Generated by GitHub Copilot
import { useTranslation } from 'react-i18next'
import User from '#core/entities/auth/users/User.ts'
import { useUserState } from '#core/state/UserState.ts'
import { ConfirmModal } from '#components/primitives/components/confirm-modal.tsx'
import type { AuthenticatorAppState } from './authenticator-app-state.ts'

/** Confirms removing the authenticator app, naming the companies that lock at the next sign-in without it. */
export function AuthenticatorAppRemoveDialog({ isOpen, state, onClose }: { isOpen: boolean; state: AuthenticatorAppState; onClose: () => void }) {
  const { t } = useTranslation('settings')
  const userState = useUserState()
  const locking = User.mfaRequiredCompanies(userState.user)

  return (
    <ConfirmModal
      isOpen={isOpen}
      title={t('security.authenticator.removeDialog.title')}
      message={t('security.authenticator.removeDialog.message')}
      warning={locking.length > 0 && (
        <>
          <p className="mb-1">{t('security.authenticator.removeDialog.lockWarning')}</p>
          <ul className="mb-0 ps-3">
            {locking.map((company) => <li key={company.id}>{company.name}</li>)}
          </ul>
        </>
      )}
      confirmLabel={t('shared.actions.remove')}
      cancelLabel={t('shared.actions.cancel')}
      genericErrorLabel={t('security.authenticator.removeDialog.error')}
      onClose={onClose}
      onConfirm={() => state.remove()}
    />
  )
}
